'use client';

import { cn, Div, Label, Span } from '@scatterlab/zeta-core';
import { memo, useId } from 'react';

import { Warning16Icon } from './icons';
import Input, { InputProps } from './Input';

export type InputFieldProps = InputProps & {
  errorText?: string;
  helperText?: string;
  containerClassName?: string;
};

const InputField = ({
  errorText,
  helperText,
  containerClassName,
  id: idAsProp,
  ...props
}: InputFieldProps) => {
  const id = useId();

  return (
    <Label
      htmlFor={idAsProp || id}
      className={cn('flex flex-col gap-2', containerClassName)}
    >
      <Input id={idAsProp || id} {...props} />
      <Div className="flex min-h-4 flex-row items-center gap-1">
        {!!errorText && (
          <Warning16Icon className="size-4 min-h-4 text-primary-300" />
        )}
        {!!(errorText || helperText) && (
          <Span className="body12 font-medium text-white/[50%]">
            {errorText || helperText}
          </Span>
        )}
      </Div>
    </Label>
  );
};

export default memo(InputField);
